import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class CheckedItemDTO extends DataTransferObject {

    public IsChecked: boolean;

    public PDO_ID: number;

    public PrincipalPDO_ID: number;

    public UserGroupPDO_ID: number;

    public constructor() {
        super({ xmlProperties: ['IsChecked', 'PDO_ID', 'PrincipalPDO_ID', 'UserGroupPDO_ID'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.IsChecked = this.defaultFromType('bool');
        this.PDO_ID = this.defaultFromType('long');
        this.PrincipalPDO_ID = this.defaultFromType('long');
        this.UserGroupPDO_ID = this.defaultFromType('long');
    }
}

 ComponentManager.setModel('CheckedItemDTO', CheckedItemDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');